var React = require('react');

function IconChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M20 9l-8 8-8-8","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconChevronDown.defaultProps = {"width":"24","height":"24"};

module.exports = IconChevronDown;

IconChevronDown.default = IconChevronDown;
